// INR + date formatting helpers for the Billing & Expense modules.

export const fmtINR = (value) => {
  const n = Number(value || 0);
  return `\u20B9${n.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

export const fmtInvoiceNumber = (n) => {
  if (n == null) return '#0000';
  const num = String(parseInt(n, 10)).padStart(4, '0');
  return `#${num}`;
};

export const fmtDate = (iso) => {
  if (!iso) return '\u2014';
  try {
    return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return iso;
  }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const dueDefaultISO = (days = 7) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export const PAYMENT_MODES = ['Cash', 'UPI', 'Bank Transfer', 'Card', 'Cheque', 'Other'];

export const EXPENSE_CATEGORIES = [
  { id: 'material', label: 'Raw Material' },
  { id: 'labour', label: 'Labour' },
  { id: 'embroidery', label: 'Embroidery' },
  { id: 'packaging', label: 'Packaging' },
  { id: 'other', label: 'Other' },
];

export const OVERHEAD_CATEGORIES = [
  { id: 'rent', label: 'Rent' },
  { id: 'electricity', label: 'Electricity' },
  { id: 'internet', label: 'Internet' },
  { id: 'tools', label: 'Tools & Supplies' },
  { id: 'transport', label: 'Transport' },
  { id: 'other', label: 'Other' },
];

export const STATUS_LABEL = {
  paid: 'Paid',
  partial: 'Partial',
  pending: 'Pending',
};
